// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleExpandBtn_root__1ViMa"};